"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import { ProgressBarLink } from "@/components/progress-bar";
import Badge from "@/components/ui/badge";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { tv } from "@/lib/tailwind-utils";
import { cx } from "@/lib/tailwind-utils";
import { NoteAttachmentTag } from "@/types/notes";
const addTriggerBadge = tv({
  base: "group relative flex h-6 cursor-pointer items-center justify-center rounded-full border border-white/30 !bg-background/20 shadow-sm backdrop-blur-sm transition-all duration-300 hover:border-white/60 hover:!bg-background/70",
  variants: {
    expanded: {
      true: "w-24 gap-1 px-2.5",
      false: "w-6 px-0"
    }
  }
});
const addMenuEntry = tv({
  base: "flex items-center gap-2 rounded-md px-2 py-1.5 text-left text-body",
  variants: {
    intent: {
      item: "hover:bg-hover",
      link: "text-link hover:bg-hover hover:text-link-hover hover:underline"
    }
  }
});
const addPopoverContent = tv({
  base: "w-48 p-1"
});
const addEmptyState = tv({
  base: "px-2 py-3 text-center text-body text-foreground-secondary"
});
const addEmptyLink = tv({
  base: "text-link hover:text-link-hover hover:underline"
});
const addTriggerIconClass = "h-3.5 w-3.5 text-foreground-secondary transition-colors duration-300";
const addTriggerLabelClass = "overflow-hidden whitespace-nowrap text-caption-strong text-foreground-secondary";
const addMenuListClass = "flex flex-col";
const addTagDotClass = "h-3 w-3 rounded-full border border-border";
const addDividerClass = "my-1 border-t border-border";
interface ImageTagBadgeProps {
  tag?: NoteAttachmentTag;
  isAddButton?: boolean;
  onAddTag?: (tagId: string) => void;
  onRemoveTag?: (tagId: string) => void;
  availableTags?: NoteAttachmentTag[];
  assignedTagIds?: string[];
  className?: string;
}
export const ImageTagBadge: React.FC<ImageTagBadgeProps> = t0 => {
  const $ = _c(58);
  const {
    tag,
    isAddButton: t1,
    onAddTag,
    onRemoveTag,
    availableTags: t2,
    assignedTagIds: t3,
    className
  } = t0;
  const isAddButton = t1 === undefined ? false : t1;
  const availableTags = t2 === undefined ? [] : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const assignedTagIds = t4;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  let t5;
  if ($[2] !== isPopoverOpen) {
    t5 = () => {
      if (!isPopoverOpen) {
        setIsExpanded(true);
      }
    };
    $[2] = isPopoverOpen;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleMouseEnter = t5;
  let t6;
  if ($[4] !== isPopoverOpen) {
    t6 = () => {
      if (!isPopoverOpen) {
        setIsExpanded(false);
      }
    };
    $[4] = isPopoverOpen;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleMouseLeave = t6;
  let t7;
  if ($[6] !== onAddTag) {
    t7 = selectedTag => {
      onAddTag?.(selectedTag.id);
      setIsPopoverOpen(false);
      setIsExpanded(false);
    };
    $[6] = onAddTag;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handleSelectTag = t7;
  let t8;
  if ($[8] !== onRemoveTag || $[9] !== tag) {
    t8 = e => {
      e.stopPropagation();
      if (tag?.id && onRemoveTag) {
        onRemoveTag(tag.id);
      }
    };
    $[8] = onRemoveTag;
    $[9] = tag;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleRemove = t8;
  const applyOpacity = _temp;
  let t9;
  if ($[11] !== assignedTagIds) {
    t9 = t => !assignedTagIds.includes(t.id);
    $[11] = assignedTagIds;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const unassignedTags = availableTags.filter(t9);
  if (isAddButton) {
    const isTriggerExpanded = isExpanded || isPopoverOpen;
    let t10;
    if ($[13] !== className || $[14] !== isTriggerExpanded) {
      t10 = addTriggerBadge({
        expanded: isTriggerExpanded,
        className
      });
      $[13] = className;
      $[14] = isTriggerExpanded;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <FiPlus className={addTriggerIconClass} />;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    let t12;
    if ($[17] !== isTriggerExpanded) {
      t12 = isTriggerExpanded && <span className={addTriggerLabelClass}>Add tag</span>;
      $[17] = isTriggerExpanded;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] !== t10 || $[20] !== t12) {
      t13 = <Badge variant="neutral" className={t10}>{t11}{t12}</Badge>;
      $[19] = t10;
      $[20] = t12;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    let t14;
    if ($[22] !== handleMouseEnter || $[23] !== handleMouseLeave || $[24] !== t13) {
      t14 = <PopoverTrigger asChild={true}><div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={_temp2}>{t13}</div></PopoverTrigger>;
      $[22] = handleMouseEnter;
      $[23] = handleMouseLeave;
      $[24] = t13;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = addPopoverContent();
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    const t16 = unassignedTags.length > 0 ? <div className={addMenuListClass}>{unassignedTags.map(availableTag => <button key={availableTag.id} onClick={e_2 => {
        e_2.stopPropagation();
        handleSelectTag(availableTag);
      }} className={addMenuEntry({
        intent: "item"
      })} type="button"><div className={addTagDotClass} style={{
          backgroundColor: availableTag.color
        }} /><span>{availableTag.name}</span></button>)}<div className={addDividerClass} /><ProgressBarLink href="/settings/note-templates" onClick={e_3 => {
        e_3.stopPropagation();
        setIsPopoverOpen(false);
        setIsExpanded(false);
      }} className={addMenuEntry({
        intent: "link"
      })}><FiPlus className="h-3 w-3" /><span>Create new tag</span></ProgressBarLink></div> : <div className={addEmptyState()}>{availableTags.length === 0 ? <div className="flex flex-col gap-1"><div>No tags available.</div><ProgressBarLink href="/settings/note-templates" onClick={e_4 => {
          e_4.stopPropagation();
          setIsPopoverOpen(false);
          setIsExpanded(false);
        }} className={addEmptyLink()}>Create tags in Settings</ProgressBarLink></div> : <div className="flex flex-col gap-1"><div>All tags assigned</div><ProgressBarLink href="/settings/note-templates" onClick={e_5 => {
          e_5.stopPropagation();
          setIsPopoverOpen(false);
          setIsExpanded(false);
        }} className={addEmptyLink()}>Create new tag</ProgressBarLink></div>}</div>;
    let t17;
    if ($[27] !== t16) {
      t17 = <PopoverContent className={t15} align="start" onClick={_temp3}>{t16}</PopoverContent>;
      $[27] = t16;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    let t18;
    if ($[29] !== isPopoverOpen || $[30] !== t14 || $[31] !== t17) {
      t18 = <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>{t14}{t17}</Popover>;
      $[29] = isPopoverOpen;
      $[30] = t14;
      $[31] = t17;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    return t18;
  }
  const tagColor = tag?.color || "#3B82F6";
  const t10 = isExpanded ? "min-w-[4rem] gap-1 px-2" : "w-6 px-0";
  let t11;
  if ($[33] !== className || $[34] !== t10) {
    t11 = cx("group relative flex h-6 cursor-default items-center justify-center rounded-full border border-white/10 shadow-sm backdrop-blur-sm transition-all duration-300", t10, className);
    $[33] = className;
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const t12 = isExpanded ? 0.7 : 0.5;
  let t13;
  if ($[36] !== applyOpacity || $[37] !== t12 || $[38] !== tagColor) {
    t13 = applyOpacity(tagColor, t12);
    $[36] = applyOpacity;
    $[37] = t12;
    $[38] = tagColor;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t13) {
    t14 = {
      backgroundColor: t13
    };
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  const t15 = isExpanded ? "max-w-[120px] opacity-100" : "max-w-0 opacity-0";
  let t16;
  if ($[42] !== t15) {
    t16 = cx("overflow-hidden whitespace-nowrap text-caption-strong text-white transition-all duration-300", t15);
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  const t17 = tag?.name;
  let t18;
  if ($[44] !== t16 || $[45] !== t17) {
    t18 = <span className={t16}>{t17}</span>;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== handleRemove || $[48] !== isExpanded || $[49] !== onRemoveTag) {
    t19 = isExpanded && onRemoveTag && <button onClick={handleRemove} className="flex h-4 w-4 items-center justify-center rounded-full bg-white/20 text-white/70 transition-all hover:bg-white/30 hover:text-white" type="button" aria-label="Remove tag"><FiX className="h-2.5 w-2.5" /></button>;
    $[47] = handleRemove;
    $[48] = isExpanded;
    $[49] = onRemoveTag;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== handleMouseEnter || $[52] !== handleMouseLeave || $[53] !== t11 || $[54] !== t14 || $[55] !== t18 || $[56] !== t19) {
    t20 = <Badge variant="neutral" className={t11} style={t14} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={_temp4}>{t18}{t19}</Badge>;
    $[51] = handleMouseEnter;
    $[52] = handleMouseLeave;
    $[53] = t11;
    $[54] = t14;
    $[55] = t18;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  return t20;
};
function _temp(colorStr, opacity) {
  const hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorStr);
  if (hexMatch) {
    const r = parseInt(hexMatch[1], 16);
    const g = parseInt(hexMatch[2], 16);
    const b = parseInt(hexMatch[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return colorStr;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp4(e_6) {
  return e_6.stopPropagation();
}